import React from 'react';
import { Box, Link } from '@mui/material';
import { splitFacebookCommentContextTitle } from '../utils/formatFacebookActivityLine';

/**
 * Renders Facebook DYI `context_title` with a larger, bold page name when the string matches "… commented on X's …".
 */
export default function FacebookActivityLine({ text, href }) {
  const parts = splitFacebookCommentContextTitle(text);
  const lineSx = { fontSize: '1.0625rem', lineHeight: 1.55, color: '#DCE6F5' };
  const pageSx = { fontWeight: 800, fontSize: '1.2rem', lineHeight: 1.45, color: '#FFFFFF' };

  const inner = parts ? (
    <Box component="span" sx={{ display: 'block', mb: 0.5 }}>
      <strong>Activity:</strong>{' '}
      <Box component="span" sx={lineSx}>
        {parts.lead}
      </Box>
      <Box component="span" sx={pageSx}>
        {parts.pageName}
      </Box>
      <Box component="span" sx={lineSx}>
        {parts.suffix}
      </Box>
    </Box>
  ) : (
    <Box component="span" sx={{ display: 'block', mb: 0.5, fontSize: '1.0625rem', lineHeight: 1.55, color: '#DCE6F5' }}>
      <strong>Activity:</strong> {text}
    </Box>
  );

  if (href) {
    return (
      <Link
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        underline="hover"
        sx={{
          display: 'block',
          color: '#DCE6F5',
          '&:hover': { color: '#40D2B7' },
        }}
      >
        {inner}
      </Link>
    );
  }
  return inner;
}
